import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { useSimpleLoginMutation } from 'bxcommon/store/endpoints/user.endpoints';
import { toggleLogin } from 'bxcommon/store/slices/user.slice';
import BaseLogin from 'bxcommon/components/BaseLogin/BaseLogin';
import errorService, { LOGIN_ERRORS } from 'bxcommon/helpers/errors.helper';
import { api } from 'bxcommon/store/api';
import { updateRequestField } from '../../store/slices/request.slice';

export const UserLogin = () => {
  const { t: common } = useTranslation('common');

  const dispatch = useDispatch();

  const [simpleLogin] = useSimpleLoginMutation();

  const warning = useCallback((error) => {
    errorService.handleErrorToast(error, LOGIN_ERRORS);
  }, []);

  const hydrateInitRegister = async (credentials) => {
    try {
      await simpleLogin({ data: credentials }).unwrap();
    } catch (error) {
      errorService.handleErrorToast(error, LOGIN_ERRORS);
      return;
    }

    const result = await dispatch(api.endpoints.getAdvisorList.initiate({}));
    const list = result.data?.results || [];

    if (list.length) {
      await dispatch(updateRequestField(list[0]));
    }

    dispatch(toggleLogin(true));
  };

  return <BaseLogin isAdvisor login={hydrateInitRegister} warning={warning} heading={common('login.heading')} />;
};

export default UserLogin;
